<!--
  CUENTAS DONDE SE LE LIQUIDA AL COMERCIO — pantalla propia, a todo el ancho.
  Superficie plana: `.kb-seccion` y `.kb-tabla-plana`, sin tarjeta alrededor.

  Lo que salió de la pestaña vieja, y por qué:
    · el subtítulo «Un comercio puede tener cuentas en bancos y monedas
      distintas…» — lo único que decía y el título no dice («la principal es la
      que se usa si nadie elige otra») bajó pegado a la insignia Principal, que
      es el dato que describe;
    · el renglón «Sin cuenta activa no se le puede liquidar» del filtro — era el
      mismo aviso de abajo, dos veces en la misma pantalla. Queda la cinta.
-->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-20.
     Esta pantalla es una RUTA HIJA de la ficha del comercio y se dibuja dentro
     de su `<router-outlet>`. El padre ya pone la miga, el nombre del comercio,
     su estado, la tira del portal y la barra de pestañas: repetirlos acá los
     mostraba DOS VECES, uno debajo del otro, y además `kb-page` anidado dentro
     de `kb-page` duplicaba el relleno y el ancho máximo.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">


  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <!-- 🔴 LAS ACCIONES, A LA DERECHA Y CON AIRE. Juan, 2026-09-20: «el botón,
       cuando navegas entre pestañas, está a la izquierda y pegado».
       Era `kb-page-header`, que reparte título a la izquierda y acciones a la
       derecha con `justify-between`. Al sacarle el título —lo pone el padre—
       quedó UN SOLO hijo, y `justify-between` con uno solo lo manda al borde
       izquierdo. Acá se alinea a la derecha a propósito, y `pt-1` lo despega de
       la barra de pestañas de arriba. -->
  <div class="flex flex-wrap items-center justify-end gap-2 pt-2">

    <div class="flex shrink-0 flex-wrap items-center gap-2" *ngIf="!cargando && !noEncontrado">
      <!-- GUI-09: la guía de liquidación, abierta en el rol del verificador. -->
      <a class="kb-btn kb-btn-outline" *ngIf="puedeVerificar" routerLink="/console/liquidacion/guia" [queryParams]="{ rol: 'verificador' }">
        <i class="fas fa-book-open" aria-hidden="true"></i>Guía
      </a>
      <!-- 2026-09-24: sin cuentas, el botón vive en el aviso vacío; éste lo repetía. -->
      <button type="button" class="kb-btn kb-btn-primary"
              *ngIf="cuentas.length && puede('update') && !formCuenta" (click)="abrirFormCuenta()">
        <i class="fas fa-plus" aria-hidden="true"></i>Agregar una cuenta
      </button>
    </div>
  </div>

  <!-- ══ Cargando ═════════════════════════════════════════════════════════════ -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-14 w-full"></div>
    <div class="kb-skeleton h-48 w-full"></div>
  </div>

  <!-- ══ No existe el comercio ════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <ng-container *ngIf="!cargando && !noEncontrado">

    <!-- ── LA CINTA: es la decisión de la pantalla, y va sola ──────────────── -->
    <!-- 2026-09-24: la cinta sólo cuando HAY cuentas pero ninguna activa. Sin ninguna cargada lo
         dice el aviso vacío de abajo, y las dos frases repetían lo mismo. -->
    <div class="kb-cinta" *ngIf="cuentasCargadas && cuentas.length && !cuentasActivas.length">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Sin cuenta de liquidación activa.</strong>
        No se le puede liquidar hasta que se cargue una.
      </p>
    </div>

    <!-- 3.5 (08-oct): hay cuentas activas pero ninguna verificada → no se le liquida. -->
    <div class="kb-cinta" *ngIf="cuentasCargadas && ningunaPagable" role="status">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Ninguna cuenta verificada.</strong>
        No se le liquida hasta que otra persona que la que la cargó la verifique con la constancia del banco.
      </p>
    </div>
    <div class="kb-aviso kb-aviso-alerta" *ngIf="avisos.length" role="status">
      <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
      <div><p class="m-0" *ngFor="let a of avisos">{{ a }}</p></div>
    </div>

    <!-- ══ El alta, en la página ═════════════════════════════════════════════ -->
    <section class="kb-tarjeta" *ngIf="formCuenta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Nueva cuenta</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <div class="grid max-w-3xl grid-cols-1 gap-5 sm:grid-cols-2">
        <div class="sm:col-span-2">
          <label class="kb-label" for="ctaNumero">
            Número de cuenta <span class="text-destructive">*</span>
          </label>
          <input id="ctaNumero" type="text" class="kb-input font-mono"
                 placeholder="p. ej. 0102-0501-23-0000123456" [(ngModel)]="cuentaNueva.account_number"
                 name="account_number">
        </div>

        <div class="sm:col-span-2">
          <label class="kb-label" for="ctaAlias">Alias</label>
          <input id="ctaAlias" type="text" class="kb-input" placeholder="p. ej. Cuenta principal"
                 [(ngModel)]="cuentaNueva.alias" name="alias">
          <p class="kb-hint">Cómo la llama el comercio. Un número de cuenta no le dice nada a nadie.</p>
        </div>

        <div>
          <label class="kb-label" for="ctaTitular">Titular</label>
          <input id="ctaTitular" type="text" class="kb-input"
                 [(ngModel)]="cuentaNueva.holder" name="holder">
        </div>

        <div>
          <label class="kb-label" for="ctaRif">RIF del titular</label>
          <input id="ctaRif" type="text" class="kb-input font-mono" placeholder="J-00000000-0"
                 [(ngModel)]="cuentaNueva.tax_id" name="tax_id">
        </div>

        <div>
          <label class="kb-label" for="ctaTipo">Tipo de cuenta</label>
          <div class="kb-select-envoltorio">
            <select id="ctaTipo" class="kb-select" [(ngModel)]="cuentaNueva.account_type"
                    name="account_type">
              <option value="CORRIENTE">Corriente</option>
              <option value="AHORRO">Ahorro</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
        </div>

        <div>
          <label class="kb-label" for="ctaMoneda">Moneda</label>
          <div class="kb-select-envoltorio">
            <select id="ctaMoneda" class="kb-select" [(ngModel)]="cuentaNueva.currency_code"
                    name="currency_code">
              <option value="VES">Bolívares</option>
              <option value="USD">Dólares</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
        </div>

        <div class="sm:col-span-2">
          <label class="flex items-center gap-2 text-sm text-foreground" *ngIf="cuentasActivas.length">
            <input type="checkbox" class="h-4 w-4 rounded border-input"
                   [(ngModel)]="cuentaNueva.is_default" name="is_default">
            Hacerla la cuenta principal
          </label>
          <p class="kb-hint" *ngIf="!cuentasActivas.length">
            Es la primera cuenta del comercio, así que queda como principal.
          </p>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <button type="button" class="kb-btn kb-btn-primary"
                [disabled]="!cuentaValida || guardandoCuenta" (click)="guardarCuenta()">
          <i class="fas" [ngClass]="guardandoCuenta ? 'fa-spinner fa-spin' : 'fa-check'"
             aria-hidden="true"></i>
          {{ guardandoCuenta ? 'Guardando…' : 'Agregar la cuenta' }}
        </button>
        <button type="button" class="kb-btn kb-btn-ghost" [disabled]="guardandoCuenta"
                (click)="cerrarFormCuenta()">Cancelar</button>
        <span class="ml-auto text-xs font-medium text-amber-700 dark:text-amber-400"
              *ngIf="!cuentaValida">
          <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i>
          Falta el número de cuenta
        </span>
      </div>
      </div>
    </section>

    <!-- ══ Las cuentas ═══════════════════════════════════════════════════════ -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Cuentas registradas</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <div class="kb-tabla-plana" *ngIf="cuentas.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Cuenta</th>
              <th class="kb-th">Titular</th>
              <th class="kb-th">Estado</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <!-- Una cuenta dada de baja se hunde, pero sigue legible: hace falta
                 para saber a dónde se le pagó antes. -->
            <ng-container *ngFor="let c of cuentas; trackBy: porId">
            <tr class="kb-tr" [ngClass]="{'kb-tr-atenuada': c.status === false}">
              <td class="kb-td">
                <span class="kb-td-titulo font-mono">{{ c.account_number }}</span>
                <p class="kb-td-sub" *ngIf="c.alias">{{ c.alias }}</p>
                <p class="kb-td-sub" *ngIf="c.bank_name">{{ c.bank_name }}</p>
                <p class="kb-td-sub">{{ tipoCuenta(c.account_type) }} · {{ c.currency_code || '—' }}</p>
              </td>
              <td class="kb-td min-w-[180px]">
                <span class="block" *ngIf="c.holder">{{ c.holder }}</span>
                <span class="kb-td-sub block whitespace-nowrap font-mono" *ngIf="c.tax_id">{{ c.tax_id }}</span>
                <span class="kb-td-sub" *ngIf="!c.holder">Sin titular</span>
              </td>
              <td class="kb-td">
                <div class="flex flex-col items-start gap-1">
                  <span class="kb-badge kb-badge-marca" *ngIf="c.is_default">
                    <i class="fas fa-star" aria-hidden="true"></i>Principal
                  </span>
                  <!-- El renglón que estaba de subtítulo, pegado al dato que describe. -->
                  <span class="kb-dato-nota" *ngIf="c.is_default">
                    se usa si nadie elige otra al liquidarle
                  </span>
                  <ng-container *ngIf="c.status !== false" [ngSwitch]="c.verification?.state">
                    <span class="kb-badge kb-badge-exito" *ngSwitchCase="'VERIFICADA'">
                      <i class="fas fa-check-circle" aria-hidden="true"></i>Verificada
                    </span>
                    <span class="kb-badge kb-badge-peligro" *ngSwitchCase="'RECHAZADA'">
                      <i class="fas fa-times-circle" aria-hidden="true"></i>Rechazada
                    </span>
                    <span class="kb-badge kb-badge-alerta" *ngSwitchDefault>
                      <i class="fas fa-hourglass-half" aria-hidden="true"></i>Por verificar
                    </span>
                  </ng-container>
                  <span class="kb-dato-nota" *ngIf="c.status !== false && c.para_pagar?.motivo">{{ c.para_pagar?.motivo }}</span>
                  <span class="kb-dato-nota" *ngFor="let a of (c.para_pagar?.avisos || [])">{{ a }}</span>
                  <span class="kb-badge kb-badge-neutro" *ngIf="c.status === false">
                    <i class="fas fa-archive" aria-hidden="true"></i>De baja
                  </span>
                </div>
              </td>
              <!-- 3.5: las acciones apiladas a la derecha; en fila se salían de la tabla. -->
              <td class="kb-td-acciones">
                <div class="flex flex-col items-end gap-1">
                  <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                          *ngIf="puedeVerificar && c.status !== false && c.verification?.state !== 'VERIFICADA' && c.verification?.state !== 'RECHAZADA'"
                          [attr.aria-expanded]="verificando === c._id" (click)="abrirVerificacion(c)">
                    <i class="fas fa-user-check" aria-hidden="true"></i>Verificar
                  </button>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="c.history?.length"
                          [attr.aria-expanded]="historialAbierto === c._id" (click)="verHistorial(c)">
                    <i class="fas fa-history" aria-hidden="true"></i>Ver historial
                  </button>
                <div class="kb-acciones-grupo" *ngIf="puede('update') && c.status !== false">
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                          *ngIf="!c.is_default" (click)="marcarPrincipal(c)">
                    <i class="fas fa-star" aria-hidden="true"></i>Hacerla la principal
                  </button>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon text-destructive"
                          aria-label="Dar de baja la cuenta" title="Dar de baja la cuenta"
                          (click)="bajarCuenta(c)">
                    <i class="fas fa-trash-alt" aria-hidden="true"></i>
                  </button>
                </div>
                </div>
              </td>
            </tr>

            <!-- ── Verificar, en la fila (CTA-02): sin diálogos ───────────────── -->
            <tr *ngIf="verificando === c._id">
              <td class="kb-td bg-muted/40" colspan="4">
                <div class="flex flex-col gap-3 py-1">
                  <p class="m-0 text-sm text-foreground" *ngIf="laCargueYo(c)">
                    <i class="fas fa-user-lock mr-1.5 text-muted-foreground" aria-hidden="true"></i>
                    La cargaste tú: la verifica otra persona.
                  </p>
                  <ng-container *ngIf="!laCargueYo(c)">
                    <p class="m-0 text-sm text-muted-foreground">
                      Compárala con la constancia del banco: número {{ c.account_number }}, titular {{ c.holder || '—' }}{{ c.tax_id ? ' · ' + c.tax_id : '' }}.
                    </p>
                    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                      <div>
                        <label class="kb-label" for="ctaConstancia">Constancia del banco</label>
                        <input id="ctaConstancia" type="text" class="kb-input" [(ngModel)]="constancia" name="constancia"
                               placeholder="p. ej. Constancia BDV del 08-oct (PDF en el expediente)">
                      </div>
                      <div>
                        <label class="kb-label" for="ctaMotivo">Motivo, si la rechazas</label>
                        <input id="ctaMotivo" type="text" class="kb-input" [(ngModel)]="motivo" name="motivo"
                               placeholder="p. ej. la constancia es de otra cuenta">
                      </div>
                    </div>
                    <p class="kb-error m-0" *ngIf="errorVerificacion" role="alert">{{ errorVerificacion }}</p>
                    <div class="flex flex-wrap items-center gap-2">
                      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90"
                              [disabled]="enviandoVerificacion" (click)="verificar(c)">
                        <i class="fas fa-check" aria-hidden="true"></i>{{ enviandoVerificacion ? 'Guardando…' : 'Verificar la cuenta' }}
                      </button>
                      <button type="button" class="kb-btn kb-btn-outline" [disabled]="enviandoVerificacion" (click)="rechazar(c)">
                        Rechazar
                      </button>
                      <button type="button" class="kb-btn kb-btn-ghost" [disabled]="enviandoVerificacion" (click)="abrirVerificacion(c)">
                        Cancelar
                      </button>
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>

            <!-- ── Historial: solo crece (regla de traza) ─────────────────────── -->
            <tr *ngIf="historialAbierto === c._id">
              <td class="kb-td bg-muted/40" colspan="4">
                <ol class="m-0 flex list-none flex-col gap-2 p-0">
                  <li class="flex flex-wrap items-baseline gap-x-3 text-sm" *ngFor="let h of c.history">
                    <span class="tabular-nums text-muted-foreground">{{ h.en | date:'dd/MM/yyyy HH:mm' }}</span>
                    <span class="text-foreground">{{ accion(h.accion) }}</span>
                    <span class="kb-dato-nota">por {{ quien(h.usuario) }}</span>
                    <span class="kb-dato-nota" *ngIf="h.motivo">· {{ h.motivo }}</span>
                    <span class="kb-dato-nota" *ngIf="h.constancia">· constancia: {{ h.constancia }}</span>
                    <span class="kb-dato-nota" *ngIf="h.antes && h.despues">
                      · {{ h.antes.account_number !== h.despues.account_number ? 'número' : (h.antes.holder !== h.despues.holder ? 'titular' : 'datos de la cuenta') }} cambiado
                    </span>
                  </li>
                </ol>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>

      <div class="kb-empty" *ngIf="cuentasCargadas && !cuentas.length">
        <span class="kb-empty-icono"><i class="fas fa-university" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Todavía no hay ninguna cuenta cargada</p>
        <p class="kb-empty-texto">
          Es donde se le deposita lo que se le liquida. Hasta que haya una, no se le puede pagar.
        </p>
        <button type="button" class="kb-btn kb-btn-primary mt-4"
                *ngIf="puede('update') && !formCuenta" (click)="abrirFormCuenta()">
          <i class="fas fa-plus" aria-hidden="true"></i>Agregar una cuenta
        </button>
      </div>

      <div class="kb-empty" *ngIf="!cuentasCargadas">
        <span class="kb-empty-icono"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Cargando las cuentas…</p>
      </div>
      </div>
    </section>

  </ng-container>
</div>
